import * as actions from './actions';

const initialState = {
    isFetchingHousingData: false,
    isFetchingPipelineData: false,
    housingDataFetchSuccess: false, // Do you need these?
    housingDataFetchFail: false,    // Do you need these?
    housingData: null,
    pipelineData:null,
    error: '',
    isFetchingSnapshot: false,
    snapshotData: null,
    uploadData: null,
    isUploading: false,
    uploadError: '',
    agencyList: [],
    housingNPUData:null,
};

export default function housing(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_HOUSING_DATA_START:
            return {
                ...state,
                isFetchingHousingData: true
            }
        case actions.FETCH_HOUSING_DATA_SUCCESS:
            return {
                ...state,
                isFetchingHousingData: false,
                housingData: action.payload,
            }
        case actions.FETCH_HOUSING_DATA_FAIL:
            return {
                ...state,
                isFetchingHousingData: false,
                error: action.error
            }
        case actions.FETCH_PIPELINE_DATA_START:
            return {
                ...state,
                isFetchingPipelineData: true
            }
        case actions.FETCH_PIPELINE_DATA_SUCCESS:
            return {
                ...state,
                isFetchingPipelineData: false,
                pipelineData: action.payload,
            }
        case actions.FETCH_PIPELINE_DATA_FAIL:
            return {
                ...state,
                isFetchingPipelineData: false,
                error: action.error
            }
        case actions.FETCH_SNAPSHOT_START:
            return {
                ...state,
                isFetchingSnapshot: true,
            }
        case actions.FETCH_SNAPSHOT_SUCCESS:
            return {
                ...state,
                isFetchingSnapshot: false,
                snapshotData: action.payload,
            }
        case actions.FETCH_SNAPSHOT_FAIL:
            return {
                ...state,
                isFetchingSnapshot: false,
                error: action.error
            }
        case actions.UPLOAD_FILE_START:
            return {
                ...state,
                isUploading: true,
            }
        case actions.UPLOAD_FILE_SUCCESS:
            return {
                ...state,
                isUploading: false,
                uploadData: action.payload
            }
        case actions.UPLOAD_FILE_FAIL:
            return {
                ...state,
                isUploading: false,
                uploadError: action.error
            }
        case actions.CLEAR_UPLOAD_ERRORS:
            return {
                ...state,
                uploadError: ''
            }
        case actions.FETCH_AGENCY_LIST_SUCCESS:
            return {
                ...state,
                agencyList: action.payload,
            }
        case actions.FETCH_HOUSING_NPU_SUCCESS:
            return {
                ...state,
                housingNPUData: action.payload,
            }
        default:
            return state;
    }
}